import React from 'react';
import { IntlProvider } from 'react-intl';

import { useUserStore } from '@store/use-user-store';

import deMessages from './locales/de.json';
import enMessages from './locales/en.json';
import huMessages from './locales/hu.json';

const allMessages = {
  en: enMessages,
  hu: huMessages,
  de: deMessages
};

export const SUPPORTED_LANGUAGES = Object.keys(allMessages);

export function I18nProvider({ children }: { children: React.ReactNode }) {
  const { selectedLang: locale } = useUserStore();
  return (
    <IntlProvider
      locale={locale}
      messages={allMessages[locale as keyof typeof allMessages]}
    >
      {children}
    </IntlProvider>
  );
}
